import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import type { UserRole } from '../types/auth'
import AdminDashboard from './dashboards/AdminDashboard'
import ClientDashboard from './dashboards/ClientDashboard'
import OrgAdminDashboard from './dashboards/OrgAdminDashboard'
import VetDashboard from './dashboards/VetDashboard'

const dashboardMap: Partial<Record<UserRole, React.ComponentType>> = {
  super_admin: AdminDashboard,
  org_admin: OrgAdminDashboard,
  staff: VetDashboard,
  client: ClientDashboard,
}

export default function Dashboard() {
  const { user } = useAuth()
  if (!user) return null
  const RoleDashboard = dashboardMap[user.role]
  if (!RoleDashboard) return <Navigate to="/profile" replace />
  return <RoleDashboard />
}
